var allowSubmit = false;

function onCaptchaFilled() {
    allowSubmit = true;
}

function onCaptchaExpired() {
    allowSubmit = false;
}

var dialog = document.querySelector('dialog');

if (! dialog.showModal) {
    dialogPolyfill.registerDialog(dialog);
}

dialog.querySelector('#close-captcha-dialog').addEventListener('click', function () {
    dialog.close();
});

$('#crmWebToEntityForm').submit(function (e) {
    if (allowSubmit) {
        return true;
    }

    e.preventDefault();
    dialog.showModal();
    mixpanel.track('Show captcha error');
});